import React from 'react';
import { TextStyled } from '@nike/nike-design-system-components';

const ChinaJanuary2025Notice = () => (
  <div>
    <div style={{ marginBottom: '10px' }}>
      <TextStyled bold appearance='body2'>
        China New Year Order Delivery
      </TextStyled>
    </div>
    <div>
      <TextStyled appearance='body2'>Orders placed by Feb 9, 2026 will deliver by the Spring Festival</TextStyled>
      <TextStyled appearance='body2'>Orders placed after Feb 9, 2026 will deliver after the Spring Festival</TextStyled>
      <TextStyled appearance='body2'>Order delivery after February 20, 2026 will return to normal</TextStyled>
    </div>
    <br />
    <div style={{ marginBottom: '10px' }}>
      <TextStyled bold appearance='body2'>
        春节期间订单配送
      </TextStyled>
    </div>
    <div>
      <TextStyled appearance='body2'>2026年2月9日前下的订单将在春节前配送</TextStyled>
      <TextStyled appearance='body2'>2026年2月9日之后的订单将在春节后配送</TextStyled>
      <TextStyled appearance='body2'>2026年2月20日之后订单配送恢复正常</TextStyled>
    </div>
  </div>
);

export default ChinaJanuary2025Notice;
